import type { ExpenseEntry, ExpenseDraft } from '@alexiarest/shared';

/** Campos leídos que siguen siendo válidos después de editar base/tipo. */
export function retainedInvoiceFields(entry: ExpenseEntry | undefined, netAmount: number, vatPct: number) {
  const sameBase = entry?.netAmount === netAmount;
  const sameTax = sameBase && entry?.vatPct === vatPct;
  return {
    subtotalBeforeDiscount: sameBase ? entry?.subtotalBeforeDiscount : undefined,
    discountAmount: sameBase ? entry?.discountAmount : undefined,
    taxAmount: sameTax ? entry?.taxAmount : undefined,
    invoiceTotal: sameTax ? entry?.invoiceTotal : undefined,
    taxMode: sameTax ? entry?.taxMode : undefined,
  };
}

/** Recalcula toda la identidad subtotal − descuento + impuesto = total. */
export function correctScannedVat(prev: ExpenseDraft, vatPct: number): ExpenseDraft {
  const single = { ...prev, vatPct, taxMode: 'single' as const, vatBreakdown: undefined, vatNote: undefined };
  // El ancla es el total LEIDO del documento (que cambiarTotal ya actualiza si
  // se corrige a mano), no invoiceTotal: ese es derivado y editar la base lo
  // arrastra, con lo que corregir el tipo dejaria de enderezar el desglose.
  const total = prev.totalLeido ?? prev.invoiceTotal;
  if (total == null || vatPct < 0 || vatPct >= 100) {
    return { ...single, taxAmount: undefined, vatAmount: undefined };
  }
  const netAmount = Math.round(total / (1 + vatPct / 100) * 100) / 100;
  const taxAmount = Math.round((total - netAmount) * 100) / 100;
  const subtotalBeforeDiscount = prev.subtotalBeforeDiscount == null ? undefined
    : Math.round((netAmount + (prev.discountAmount ?? 0)) * 100) / 100;
  return { ...single, netAmount, taxAmount, vatAmount: taxAmount, invoiceTotal: total, subtotalBeforeDiscount };
}
